import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as metricsActions from '../actions/metric.actions';
import { Metric } from '../types/metric.type';

export type MetricState = Metric[];

declare module 'react-redux' {
  interface DefaultRootState {
    metrics: MetricState;
  }
}

const initialStateFactory = (): MetricState => [];

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(metricsActions.loaded, (_, { metrics }) => metrics),
  on(undoActions.undo, undoActions.restore, (state, { diff: { metrics } }) => {
    if (!metrics) {
      return state;
    }
    return metrics;
  }),
);
